<template>
  <div class="content">
    <!-- <div class="search-box">
      <van-search
        v-model="searchText"
        placeholder="搜索医生或科室"
        @search="toSearch"
      />
    </div> -->

    <!-- <div class="tree-select-box">
      <van-tree-select
        height="100%"
        @click-item="goSelectRoom"
        :items="items"
        :main-active-index.sync="activeIndex"
      />
    </div> -->
    <div class="tree-select-box">
      <van-tree-select
        height="100%"
        @click-item="goSelectDoctor"
        :items="items"
        :main-active-index.sync="activeIndex"
        style="font-size: 18px;"
      />
    </div>
  </div>
</template>

<script>
import { selectDept } from '@/api/api'
import { reckonDate, _date_ } from '../../utils/calculationDate'
export default {
  name: 'selectDepartment',
  data() {
    return {
      searchText: '',
      activeIndex: 0,
      items: [],
      selectWk: '',
      reckonDateList: []
    }
  },
  created() {},
  mounted() {
    this.getDept()
    this.reckonDateList = reckonDate()
    this.selectWk = this.reckonDateList[0].dateStr
  },
  methods: {
    getDept() {
      this.$loading.show()
      selectDept().then(res => {
        if (res.length) {
          this.$loading.hide()
          this.items = res
        }
      })
    },
    // goSelectRoom(data) {
    //   if (this.$route.params.returnPack == 'preventionIndex') {
    //     this.$router.push({
    //       name: this.$route.params.returnPack,
    //       params: { returnData: data }
    //     })
    //   } else {
    //     // 缓存选中科室数据
    //     localStorage.setItem('department', JSON.stringify(data))
    //     this.$router.push({
    //       name: 'selectRoom'
    //     })
    //   }
    // },

    goSelectDoctor(data) {
      let D = {
        ...this.selectedDepartmentData,
        clinicRoomNo: data.code,
        dateStr: this.selectWk
      }
      localStorage.setItem('department', JSON.stringify(D))
      this.$router.push({
        name: 'selectDoctor'
      })
    },
    // 搜索
    toSearch() {
      this.$router.push({
        name: 'searchResult',
        query: {
          name: this.searchText
        }
      })
    }
  }
}
</script>

<style scoped>
.content {
  font-size: 18px;
}
.search-box {
  width: 100vw;
  height: 54px;
  border-bottom: 1px solid #ebedf0;
}
.tree-select-box {
  width: 100vw;
  /* height: calc(100vh - 55px); */
  height: 100vh;
}
.tree-select-box .van-sidebar-item {
  font-size: 18px;
}
</style>
